import { CardContent } from "@mui/material";
import { Card, TextSkeleton } from "@src/appV2/redesign/system/ui-components";

export function LicenseCardSkeleton() {
  return (
    <Card outlined variant="quaternary" sx={{ flexShrink: 0, minHeight: "11rem" }}>
      <CardContent>
        <TextSkeleton variant="body1" width="50%" />
      </CardContent>
    </Card>
  );
}
